/* eslint-disable react-hooks/rules-of-hooks  */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { subDays } from 'date-fns'
//Rows and col's data
import ConversationTableHeader from "./sub/ConversationTableHeader/index";
import ConversationTableBody from "./sub/ConversationTableBody/index";
import ConversationTableFooter from "./sub/ConversationTableFooter/index";

import ChatTransfer from "../../../../../../../OperatorArea/components/ChatTransfer/index";
import CloseChat from "../../../../../../../OperatorArea/components/CloseChat/index";

import "./ConversationTable.scss";
import SpyChat from "../../../../../../../OperatorArea/components/SpyChat";
import * as dateFns from "date-fns";
import {
  apiError,
  resetError,
  getConversations,
  getConversationsForm,
  setConversationsFilter,
} from "../../../../../../../../store/manager/actions";
import { resetStatus } from "../../../../../../../../store/operator/actions";

import DateTime from "luxon/src/datetime.js";

import { useDispatch, useSelector } from "react-redux";

import { withTranslation } from "react-i18next";

import axios from "axios";
import { showToast } from "../../../../../../../../Libs/CustomMethods/showToast";
import TransferToSkillErroModel from '../../../../../../../OperatorArea/components/TransferToSkillErroModel';
import { useInView } from "react-intersection-observer";

const index = ({ t, onExpand }) => {
  const dispatch = useDispatch();
  const {
    dataConversation,
    dataConversationForm,
    dataConversationFilter,
    loadingConversation,
    loadingConversationForm,
    errorConversation,
  } = useSelector((state) => state.Manager);

  const userPreferences =
    useSelector((state) => state.Login?.data?.preferences) || {};

  //If client feature is by clients, remove line below
  const { data } = useSelector((state) => state.Login);
  const [transferChat, setTransfChat] = useState(false);
  const [closeChat, setCloseChat] = useState(false);
  const [spyChat, setSpyChat] = useState(false);
  const [conversationId, setSetConversationId] = useState("");
  const [skillId, setSkillId] = useState();
  const [skillName, setSkillName] = useState(); // TODO: remove it when api is updated
  const [skillIsPriority, setSkillIsPriority] = useState(false);
  const [tabId, setTabId] = useState("");
  const [consumerName, setConsumerName] = useState("");
  const [refreshButton, setRefreshButton] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [messagesErros, setMessagesErrors] = useState([]);
  const [showModalErros, setShowModalErros] = useState(false);

  const [massActions, setMassActions] = useState({
    conversations: [],
    globalTab: false,
  });
  const [conversationsCheckedArray, setConversationsCheckedArray] = useState({
    list: [],
    all: false,
  });

  const handleClickCloseModalRequest = useCallback(()=>{
    setShowModalErros(false);
    setMessagesErrors([]);
  },[]);

  const handleClickOpenModalRequest = useCallback(()=>{
    setShowModalErros(true);    
  },[]);

  const setDefaultPeriod = () => {
    const start = new Date().setDate(new Date().getDate() - 1);
    const end = new Date();

    const date = [new Date(start), end];

    return date;
  };
  const defaultDate = setDefaultPeriod();
  const intervalRef = React.useRef({
    conversation: null,
    pauseRefresh: null,
  });

  const [filterCustom, setFilterCustom] = useState(
    dataConversationFilter?.toForm ?? { date: defaultDate }
  );
  const [filterCustomToSend, setFilterCustomToSend] = useState(
    dataConversationFilter?.toSend ?? {}
  );
  const [timerControl, setTimeControl] = useState(null);
  const [total, setTotal] = useState(1);
  const [page, setPage] = useState(1);
  const qtdDefault = 13;
  //If client feature is by clients, remove line below
  const objFeatureTab = data?.features.find((e) => e.name === "Tab");
  const [orderCustom, setOrderCustom] = useState({
    name: "status",
    order: -1,
  });

  const lastUpdateRef = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });

  const hasItemSelected =
    conversationsCheckedArray?.list?.filter(Boolean)?.length > 0;

  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const resetSelects = () => {
    setConversationsCheckedArray({
      list: [],
      all: false,
    });
  };

  const toggleFilter = (e) => {
    e ? setIsOpenFilter(e) : setIsOpenFilter(!isOpenFilter);
  };

  const toggleTransferChat = () => setTransfChat(!transferChat);
  const toggleCloseChat = () => {
    setCloseChat(!closeChat);
  };
  const toggleSpyChat = () => {
    setSpyChat(!spyChat);
  };

  const conversationDownload = (data) => {
    let chatId = data?.id;
    setLoadingDownload((prev) => ({ ...prev, [chatId]: true }));
    axios
      .get(`/conversation-download?${chatId ? `&id=${chatId}` : ""}`, {
        method: "GET",
        responseType: "blob", //Force to receive data in a Blob Format
      })
      .then((response) => {
        setLoadingDownload((prev) => ({ ...prev, [chatId]: false }));
        const file = new Blob([response.data], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      })
      .catch((error) => {
        setLoadingDownload((prev) => ({ ...prev, [chatId]: false }));
        showToast(t("There was an error downloading conversation"), "error");
      });
  };

  const conversationTransfer = (data) => {
    setSetConversationId(data.id);

    setSkillId(data.skill_id);
    setSkillName(data.skill_name);
    setSkillIsPriority(data.enable_priority);
    setConsumerName(data.consumer_name);
    setTransfChat(true);
  };
  const conversationClose = (data) => {
    if (data?.isMassActions) {
      const { conversations, globalTab } = data;
      setSetConversationId(conversations[0].id);
      setTabId(conversations[0].conversation_tab);
      setConsumerName(conversations[0].consumer_name);
      setCloseChat(true);
      setMassActions({
        conversations,
        globalTab,
      });

      return;
    }

    setSetConversationId(data.id);
    setTabId(data.conversation_tab);
    setConsumerName(data.consumer_name);
    setCloseChat(true);
    setMassActions({
      conversations: [],
      globalTab: false,
    });
  };
  const conversationSpy = (data) => {
    setSetConversationId(data.id);
    setSpyChat(true);
  };

  const handleErrorSuccess = (e) => {    
    dispatch(resetStatus("close_chat"));
    if (!e.error && e.message) {
      showToast(t(e.message), "success");
      handleRefresh();
    } else if (e.error && Array.isArray(e.message) && e.message.length > 0) {
      e.message.map((error) => showToast(t(error.value), "error"));
    }else if(typeof e.message === 'string' && e.body){
      const msg = [];
      
      if(e?.body?.skillsInExceptions || e?.body?.skillsNotInWorkScheludes){
        toggleTransferChat();
        let date = null;
        try {
          date = dateFns.format(new Date(e?.body?.nextOnDate),'dd/MM/yyyy HH:mm');
          date = date.split(' ')
          date = `${date[0]} - ${date[1]}`;
        } catch (error) {
          
        }
        const text = `${t(`The call cannot be transferred as the selected skill is out of call hours and will return on`)} ${date}`
        msg.push(text);
      }else if(e?.body?.hasUsersOnline === false){
        toggleTransferChat();
        msg.push(t(`The call cannot be transferred because there are no operators logged into this skill`));  
      }
      
      setMessagesErrors(msg);
      handleClickOpenModalRequest();
    }
  };

  const handlePage = (value, loading = true) => {
    if (!inView) return;
    setPage(value);
    resetSelects();
    setRefreshButton(loading);
    lastUpdateRef.current = new Date();
    if (filterCustomToSend?.date) {
      dispatch(
        getConversations(
          value,
          qtdDefault,
          filterCustomToSend,
          orderCustom.name,
          orderCustom.order
        )
      );
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataConversation && dataConversation.paging) {
      if (page < dataConversation.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const validateInputs = (input) => {
    const error = [];
    let isValid = true;
    dispatch(resetError());
    if (input?.message) {
      const start = input?.date?.[0] ? new Date(input?.date[0]).getTime() : 0;
      const end = input?.date?.[1]
        ? new Date(input?.date?.[1]).getTime()
        : start;
      const oneDay = 1000 * 60 * 60 * 24; // One day in milliseconds
      const diffInTime = end - start; // Calculating the time difference between two dates
      const diffInDays = Math.round(diffInTime / oneDay); // Calculating the no. of days between two dates
      if (!start || diffInDays > 7) {
        isValid = false;
        error.push({
          key: "interval",
          value:
            "To filter a message, select an interval less than or equal to 7 days",
        });
      }
      const msgLength = input?.message?.length;
      if (msgLength < 3) {
        isValid = false;
        error.push({
          key: "length",
          value: "message length must be at least 3 characters long",
        });
      }
      if (msgLength > 255) {
        isValid = false;
        error.push({
          key: "length",
          value:
            "message length must be less than or equal to 255 characters long",
        });
      }
    }
    if (!isValid) {
      dispatch(apiError(error));
    }
    return isValid;
  };

  const handleFilter = () => {
    if (validateInputs(filterCustom)) {
      toggleFilter();
      setFilterCustomToSend({
        ...filterCustomToSend,
        status:
          filterCustom?.status?.length > 0
            ? filterCustom.status.map((element) => element.value)
            : null,
        skills:
          filterCustom?.skills?.length > 0
            ? filterCustom.skills.map((element) => element.value)
            : null,
        tabs:
            filterCustom?.tabs?.length > 0
              ? filterCustom.tabs.map((element) => element.value)
              : null,
        users:
          filterCustom?.users?.length > 0
            ? filterCustom.users.map((element) => element.value)
            : null,
        consumer: filterCustom?.consumer ? filterCustom.consumer : null,

        conversation_id: filterCustom?.conversation_id
          ? filterCustom.conversation_id
          : null,
        protocol: filterCustom?.protocol ? filterCustom.protocol : null,
        message: filterCustom?.message ? filterCustom.message : null,
        extras: filterCustom?.extras ? filterCustom.extras : null,
        extrasFilters:
          filterCustom?.extrasFilters && filterCustom?.extras
            ? filterCustom.extrasFilters
            : null,
        personalInformation: filterCustom?.personalInformation
          ? filterCustom.personalInformation
          : null,
        personalInformationFilters:
          Array.isArray(filterCustom?.personalInformationFilters) &&
          filterCustom?.personalInformationFilters?.length > 0 &&
          filterCustom?.personalInformation
            ? filterCustom.personalInformationFilters
            : null,
        date:
          filterCustom?.date?.length > 0
            ? filterCustom.date.length === 1
              ? [
                  DateTime.fromJSDate(new Date(filterCustom.date[0])).toFormat(
                    "yyyy-MM-dd"
                  ),
                  DateTime.fromJSDate(new Date(filterCustom.date[0])).toFormat(
                    "yyyy-MM-dd"
                  ),
                ]
              : filterCustom.date.map((element) =>
                  DateTime.fromJSDate(new Date(element)).toFormat("yyyy-MM-dd")
                )
            : defaultDate,
      });
    }
  };

  const calculateDiff = (st, en) => {
    const date = [new Date(st), new Date(en)];

    const duration = date[1].setDate(date[1].getDate() - 30);
    const durDays = date[0].getTime() < new Date(duration).getTime();

    return durDays;
  };

  useEffect(() => {
    if (!filterCustomToSend?.date) {
      const now = new Date()
      
      let date = (() => {
        if (now.getHours() > 6) return [new Date(), new Date()]
        return [subDays(new Date(), 1), new Date()]
      })()

      date = date.map((e) => `${e.getFullYear()}-${e.getMonth() + 1}-${e.getDate()}`);

      setFilterCustomToSend({
        ...filterCustomToSend,
        date,
      });
    }
  }, []);

  const handleDatePicker = (date) => {
    if (filterCustom?.date?.length === 2) {
      setFilterCustom({
        ...filterCustom,
        date: [date],
      });
    } else {
      if (filterCustom?.date?.length === 1) {
        if (filterCustom.date[0] < date) {
          dispatch(resetError());
          if (calculateDiff(filterCustom.date[0], date)) {
            const error = [
              {
                key: "interval",
                value: "Select an interval less than or equal to 30 days",
              },
            ];
            dispatch(apiError(error));
          } else {
            setFilterCustom({
              ...filterCustom,
              date: [...filterCustom.date, date],
            });
          }
        } else {
          setFilterCustom({
            ...filterCustom,
            date: [date],
          });
        }
      } else {
        setFilterCustom({
          ...filterCustom,
          date: [date],
        });
      }
    }
  };

  const handleRefresh = () => {
    handlePage(page);
  };

  const onClearDatePicker = () => {
    setFilterCustom({
      ...filterCustom,
      date: defaultDate,
    });
  };

  const getFilterForm = () => {
    !dataConversationForm && dispatch(getConversationsForm());
  };

  const handleSort = useCallback(
    (name) => {
      let order = orderCustom.order;

      if (name) {
        order *= -1;

        if (orderCustom.name === "status" && name === "status") {
          return;
        }

        if (orderCustom.name !== name) {
          order = -1;
        } else if (order === -1 && orderCustom.name === name) {
          order = -1;
          name = "status";
        }
      } else {
        name = orderCustom.name;
      }

      setOrderCustom({
        name,
        order,
      });
    },
    [orderCustom.name, orderCustom.order]
  );

  useEffect(() => {
    setRefreshButton(true);
    handlePage(1);
  }, [orderCustom]);

  useEffect(() => {
    if (isOpenFilter) {
      getFilterForm();
    }
  }, [isOpenFilter]);

  useEffect(() => {
    if (errorConversation) {
      toggleFilter(true);
    }
  }, [errorConversation]);

  useEffect(() => {
    setTotal(dataConversation?.total);
  }, [dataConversation]);

  useEffect(() => {
    dispatch(setConversationsFilter("toSend", filterCustomToSend));
    handlePage(1);
  }, [filterCustomToSend]);

  useEffect(() => {
    dispatch(setConversationsFilter("toForm", filterCustom));
  }, [filterCustom]);

  useEffect(() => {
    if (timerControl && !hasItemSelected) {
      setRefreshButton(false);
      handlePage(page, false);
    }
  }, [timerControl]);

  useEffect(() => {
    intervalRef.current["conversation"] = setInterval(() => {
      const diffDateStartDateEnd = new Date(filterCustomToSend.date[1]) - new Date(filterCustomToSend.date[0]);
      if (filterCustomToSend?.protocol || 
        filterCustomToSend?.message ||
        filterCustomToSend?.conversation_id || 
        (filterCustomToSend?.extrasFilters && filterCustomToSend?.extras) || 
        (filterCustomToSend?.personalInformation && filterCustomToSend?.personalInformationFilters) ||
        (diffDateStartDateEnd > 86400000)
        ) return;
      setTimeControl(new Date());
    }, userPreferences?.refresh_time ?? 60000);
    return () => clearInterval(intervalRef.current?.conversation);
  }, [filterCustomToSend]);

  useEffect(() => {
    if (inView) {
      if (!lastUpdateRef.current) {
        handlePage(page);
      } else {
        const now = new Date();
        const diff = now - lastUpdateRef.current || 0;
        if (diff >= userPreferences?.refresh_time || !lastUpdateRef.current) {
          handlePage(page);
        }
      }
    }
  }, [inView, lastUpdateRef]);

  useEffect(() => {
    if (hasItemSelected) {
      if (!intervalRef.current["pauseRefresh"]) {
        intervalRef.current["pauseRefresh"] = setTimeout(() => {
          setRefreshButton(true);
          handlePage(page);
        }, 10 * 60000);
      }
    } else {
      clearInterval(intervalRef.current?.pauseRefresh);
      intervalRef.current["pauseRefresh"] = null;
    }

    return () => {
      clearInterval(intervalRef.current?.pauseRefresh);
      intervalRef.current["pauseRefresh"] = null;
    };
  }, [hasItemSelected]);

  return (
    <>
      <div className="mt-3 px-2" ref={ref}>
        <ConversationTableHeader
          onExpand={onExpand}
          setFilterCustom={(value) => {
            const date = value?.date || defaultDate;
            setFilterCustom({ ...value, date });
          }}
          filterCustom={filterCustom}
          handleFilter={handleFilter}
          handleFilterCard={getFilterForm}
          payloadDataForm={dataConversationForm}
          loadingConversationForm={loadingConversationForm}
          loadingData={loadingConversation && refreshButton}
          onClearDatePicker={onClearDatePicker}
          handleDatePicker={handleDatePicker}
          handleRefresh={handleRefresh}
          toggleFilter={toggleFilter}
          isOpenFilter={isOpenFilter}
          conversationClose={(e) => conversationClose(e)}
          conversationsChecked={{
            conversationsCheckedArray,
            setConversationsCheckedArray,
          }}
          payloadData={dataConversation?.message}
        />
        <ConversationTableBody
          qtdDefault={qtdDefault}
          payloadData={dataConversation?.message}
          loadingData={loadingConversation && refreshButton}
          conversationDownload={(e) => conversationDownload(e)}
          conversationTransfer={(e) => conversationTransfer(e)}
          conversationClose={(e) => conversationClose(e)}
          conversationSpy={(e) => conversationSpy(e)}
          loadingDownload={loadingDownload}
          conversationsChecked={{
            conversationsCheckedArray,
            setConversationsCheckedArray,
          }}
          orderBy={orderCustom}
          handleSort={handleSort}
        />
        <hr className="conversation-table-separator" />
        <ConversationTableFooter
          total={total}
          page={page}
          qtd={qtdDefault}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
        />
      </div>

      <CloseChat
        isOpen={closeChat}
        toggle={toggleCloseChat}
        activeChat={{
          conversation: {
            conversationTab: tabId,
            conversationId: conversationId,
            consumer: { name: consumerName },
          },
        }}
        onSubmit={handleErrorSuccess}
        isByManager
        //To display tabs if client feature is by clients, replace isFeatureTab to an API return like above on activeChat
        isDisplayTabs={objFeatureTab?.active}
        isTabsRequired={objFeatureTab?.required}
        massActions={massActions}
      />
      <ChatTransfer
        isOpen={transferChat}
        toggle={toggleTransferChat}
        conversationId={conversationId}
        skillId={skillId}
        skillName={skillName}
        skillIsPriority={skillIsPriority}
        clientName={consumerName}
        onSubmit={handleErrorSuccess}
        isByManager
      />

      <TransferToSkillErroModel
        title={t(`Transfer unavailable`)}
        msg={messagesErros}
        isOpen={showModalErros}
        handleClickCloseModalRequest={handleClickCloseModalRequest}
      />

      <SpyChat
        isOpen={spyChat}
        toggle={toggleSpyChat}
        conversationId={conversationId}
        isByManager
      />
    </>
  );
};

export default withTranslation()(index);
